import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Typography, Chip, Avatar } from '@mui/material';

import { longDateTimeFormat } from '../../lib/utils';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
};

function SearchAttemptsList({ searchAttempts }) {
  return (
    <div style={styles.container}>
      <Typography variant="subtitle2">
        Search Attempts
      </Typography>
      <div>
        {searchAttempts.map((attempt, index) => (
          <Chip
            color="secondary"
            avatar={<Avatar>{index + 1}</Avatar>}
            label={`${attempt.userName} ${moment(attempt.date).format(longDateTimeFormat)} ${attempt.comment || ''}`}
            style={{ marginTop: '5px' }}
          />
        ))}
      </div>
    </div>
  );
}

SearchAttemptsList.defaultProps = {
  searchAttempts: [],
};

SearchAttemptsList.propTypes = {
  searchAttempts: PropTypes.arrayOf(PropTypes.object),
};

export default SearchAttemptsList;
